module.exports = __webpack_public_path__ + "static/img/07.1ae69fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/PulpFictionZine/07.jpg
// module id = y1oP
// module chunks = 7